export const BLUR = 'blur' as const;
export const ENTER = 'enter' as const;

export const MAX_SUMMARY_LENGTH = 255 as const;
